import { Trans, useTranslation } from "react-i18next";
import { AccountDetailsLayout } from "@common/Layout/AccountDetailsLayout";
import { BarringList } from "@features/Barrings/BarringList";
import { Grid, Tooltip, Typography } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

export const BarringsPage = () => {
    const { t } = useTranslation("barrings");

    const toolTipText = (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Trans i18nKey="tooltipTextFullNetworkBar" ns="barrings" />
            </Grid>
            <Grid item xs={12}>
                <Trans i18nKey="tooltipTextPremiumSMS" ns="barrings" />
            </Grid>
            <Grid item xs={12}>
                <Trans i18nKey="tooltipTextPremiumVoice" ns="barrings" />
            </Grid>
        </Grid>
    );

    return (
        <AccountDetailsLayout
            requireNumberSelection
            selectYourNumberTitle={t("selectNumberTitle")}
            title={t("barMobileServices")}
        >
            <Grid container spacing={5}>
                <Grid item xs={12}>
                    <Typography align="center" gutterBottom>
                        <Trans i18nKey="barringDescription" ns="barrings" />
                        <Tooltip disableFocusListener disableTouchListener title={toolTipText}>
                            <HelpIcon />
                        </Tooltip>
                    </Typography>
                    <Typography align="center">
                        <Trans i18nKey="barringDescriptionWarning" ns="barrings" />
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <BarringList />
                </Grid>
            </Grid>
        </AccountDetailsLayout>
    );
};
